$(document).ready(function () {

    detectOs();

    function detectOs() {
        var OSName = "unknown-OS";
        if (navigator.appVersion.indexOf("Win") != -1) OSName = "windows";
        else if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";
        else if (navigator.appVersion.indexOf("X11") != -1) OSName = "unix";
        else if (navigator.appVersion.indexOf("Linux") != -1) OSName = "linux";

        $('body').attr('data-os', OSName);
        // console.log('Your OS is: ' + OSName);
    }

    /* DISABLE CLICK MOUSE */
    // document.addEventListener('contextmenu', event => event.preventDefault());


    let backSlide = '';
    let selectedLang = 'en';
    let langState = false;
    let currentSlide = 1;

    //debug
    let disableAnimations = true;

    function checkLang() {
        let lang = $('html').attr('lang');
        return lang;
    }


    /*
    ======
    TRANSLATOR
    ======
    */

    let englishTranslation = {
        header: {
            home_button: 'Home',
            back_button: 'Go back',
        },
    };

    let deutschTranslation = {
        header: {
            home_button: 'Start',
            back_button: 'Zurück',
        },
    };

    let polishTranslation = {
      header: {
          home_button: 'Strona główna',
          back_button: 'Powrót',
      },
    };
  

    // Create a new instance of the translator
    // You can optionally pass options
    var translator = new Translator();

    // Add the language to the translator and translate the page
    translator
        .add('en', englishTranslation)
        // .add('pl', polishTranslation)


    /*
    ======
    LANG SWITCHER
    ======
    */
    setSwitcher();

    $("#lang-switcher-button li[data-lng='" + selectedLang + "']").addClass('active');

    function setSwitcher() {
        $(".currentLang").on("click", function () {
            // console.log(langState);
            if (!langState) {
                langState = true
                showSwitcher();
            } else {
                langState = false
                $("#lang-switcher-button li").not("active").hide();
            }
        });
    }

    function showSwitcher() {
        $("#lang-switcher-button").addClass('show');
        $("#lang-switcher-button li").show();
        $("#lang-switcher-button li.active").hide();

        $("#lang-switcher-button li img").removeClass('animate__fadeOut');
        $("#lang-switcher-button li img").addClass('animate__animated');
        $("#lang-switcher-button li img").addClass('animate__fadeIn');

        $("#lang-switcher-button li").on("click", function () {
            selectedLang = $(this).data('lng')

            translator.translatePageTo(selectedLang);
            $(this).unbind('click');
            langState = false
            // console.log(selectedLang)
            $("#lang-switcher-button li img").removeClass('animate__animated');
            $("#lang-switcher-button li img").removeClass('animate__fadeIn');
            $("#lang-switcher-button li img").addClass('animate__fadeOut');
            $("#lang-switcher-button").removeClass('show');
            $("#lang-switcher-button li").removeClass('active').hide();
            $("#lang-switcher-button li[data-lng='" + selectedLang + "']").addClass('active');
            $(".currentLang img").attr('src', $("#lang-switcher-button li[data-lng='" + selectedLang + "'] img").attr('src'))

            $('video').each(function () {
                $(this).trigger('pause');
            });

            // switchSubtitlesLang();
        });
    }


    /*
    ======
    TOP NAV
    ======
    */

    function showTopNavigation() {
        $(".control-box").show();
        $(".control-box").removeClass("animate__animated animate__fadeOut");
        $(".control-box").addClass("animate__animated animate__fadeIn");
    }

    function hideTopNavigation() {
        $(".control-box").hide('300');
        $(".control-box").removeClass("animate__animated animate__fadeIn");
        $(".control-box").addClass("animate__animated animate__fadeOut");
    }

    /*
    ======
    SLIDES
    ======
    */

    // #slide-0
    slide_0();

    function slide_0() {
        currentSlide = 0;
        $(".slide").removeClass("active");
        $(".slide-0").addClass("active");
        $(".slide-0").addClass("animate__animated animate__fadeIn");
        backSlide = "";
    }

    function slideActiveByClass(slideName) {
        let $slideName = $(slideName);
        $(".slide").removeClass("active");
        $slideName.addClass("active");
        $slideName.addClass("animate__animated animate__fadeIn");

        backSlide = "";
    }


    /*
    ======
    BACK FUNCTION
    ======
    */
    // [OFF]
    backButtonsActionFn();

    function backButtonsActionFn() {
        // $("#home-button").on("click", function () {
        //     backSlide = '';
        //     resetCustomScrollbar();
        //     back();
        //     refreshSlider();
        //     resetSystemOverview();
        // });
        $("#back-button").on("click", function () {
            back();
        });
    }



    function back() {
        if (backSlide.length) {
          if( backSlide == 'active-qr-code' ) {
            qrCodeClose();
            hideTopNavigation();
          }
        }
    }

    slider();

    function slider() {

        let owl = $('.s1-slider > .owl-carousel');


        owl.owlCarousel({
            loop: false,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            margin: 0,
            nav: true,
            dots: true,
            items: 1,
            slideSpeed: 500,
            paginationSpeed: 500,
            smartSpeed: 500,
            animateOut: 'fadeOut',
            onInitialized: callback1,
            onTranslated: callbackChange1,
        });


        function callback1(event) {
            let count = event.item.count;
            $('.s1-slider').attr('data-count', count);
        }

        function callbackChange1(e) {
            let lang = $('html').attr('lang');

            // video-holder-player data-video d-none" data-lang="en"


            $('.s1-slider > .owl-carousel .owl-item').each(function (index) {
                let number = index + 1;
                $(this).attr('data-item', number);
            });
        }


    }

    function refreshSlider() {
        var $owl = $('.owl-carousel');
        $owl.trigger('to.owl.carousel', [0, 400]);

    }



    /**
     * Open QR Code
     */

    // $element; $parent 
    popupHelper('.open-popup', '.qr-popup');

    function popupHelper($element, $elementParent) {

      $($element).on('click', function(){

        $($elementParent).css({
            opacity: 0,
            display: 'flex'
        }).animate({
            opacity: 1
        }, 300);

        $($elementParent).addClass('active');

        showTopNavigation();

        backSlide = 'active-qr-code';
      });

      $($elementParent).on('click', function(){
        qrCodeClose();
        hideTopNavigation();
      });

    }
    function qrCodeClose() {
      $('.qr-popup').fadeOut('300').removeClass('active');
      $('.qr-popup').css({
        opacity: 0,
      });
    }


    /* TRIGGER TO RESET - INACTIVITY */
    userInactivity();

    function userInactivity() {

        var t;
        window.onload = resetTimer;
        window.onmousemove = resetTimer;
        window.onmousedown = resetTimer; // catches touchscreen presses as well
        window.ontouchstart = resetTimer; // catches touchscreen swipes as well
        window.ontouchmove = resetTimer;
        window.onclick = resetTimer; // catches touchpad clicks as well
        window.onkeydown = resetTimer;
        window.addEventListener('scroll', resetTimer, true); // improved; see comments

        function triggerFn() {
            $(".slide").removeClass("active animate__animated animate__fadeIn");
            qrCodeClose();
            hideTopNavigation();
            slide_0();
            refreshSlider();
        }

        function resetTimer() {
            clearTimeout(t);
            // test
            // let time = 1000 * 10 * 0.2;
            // 10 min
            let time = 1000 * 60 * 10;
            t = setTimeout(triggerFn, time); // time is in milliseconds
        }
    }


    /* CUSTOM SCROLLBAR */
    // customScrollbar();

    function customScrollbar() {
        jQuery('.scrollbar-inner').scrollbar({
            autoScrollSize: true,
            showArrows: true
        });
    }

    function resetCustomScrollbar() {
        // let $scrollBar = jQuery('.slide.active .slider .owl-carousel .owl-item .scrollbar-inner');
        let $scrollBar = jQuery('.slide.active .slider .scrollbar-inner');
        $scrollBar.scrollTop(0);
    }


});
//document.ready